import { ELEMENT_TYPE_PYP_LEARNING_STANDARD } from "Constants/stringConstants";
import ACLStore from "lib/aclStore";
import _ from "lodash";
import { DATA_GRID_COLUMN_TYPES } from "StandardsTable/modules/constants";

export const getParentNodeId = ({ parentNodes = [] }) => {
  if (_.size(parentNodes) === 1) {
    return _.get(_.first(parentNodes), "id");
  }

  return null;
};

export const getCurrentColumns = ({
  isOldSubjectBasedGrading,
  plannerElementType,
}) => {
  if (!isOldSubjectBasedGrading) {
    return [
      DATA_GRID_COLUMN_TYPES.SELECTION,
      DATA_GRID_COLUMN_TYPES.CODE,
      DATA_GRID_COLUMN_TYPES.TITLE,
      DATA_GRID_COLUMN_TYPES.POWER_STANDARD,
      DATA_GRID_COLUMN_TYPES.GRADE_LEVELS,
      DATA_GRID_COLUMN_TYPES.GRADING_TYPE,
      DATA_GRID_COLUMN_TYPES.TAGS,
      DATA_GRID_COLUMN_TYPES.DESCRIPTION,
      DATA_GRID_COLUMN_TYPES.ID,
      DATA_GRID_COLUMN_TYPES.LIST_PARENT,
      DATA_GRID_COLUMN_TYPES.ARCHIVE,
    ];
  }

  const columnIdsToDisplay = [
    DATA_GRID_COLUMN_TYPES.SELECTION,
    DATA_GRID_COLUMN_TYPES.CODE,
    DATA_GRID_COLUMN_TYPES.TITLE,
    DATA_GRID_COLUMN_TYPES.DESCRIPTION,
    DATA_GRID_COLUMN_TYPES.GRADE_LEVELS,
    DATA_GRID_COLUMN_TYPES.TAGS,
  ];

  if (
    plannerElementType === ELEMENT_TYPE_PYP_LEARNING_STANDARD &&
    ACLStore.can("TeacherPortal:PlannerBenchmarkQuestions")
  ) {
    columnIdsToDisplay.push(DATA_GRID_COLUMN_TYPES.STAAR_QUES);
  }
  return columnIdsToDisplay;
};
